var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('Grid',{attrs:{"name":"OperatorsExcludedGrid","preload":_vm.preload,"url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }